import { Platform } from 'react-native';

export type ClientPlatform = 'iOS App' | 'Android App' | 'Web App';

/**
 * Runtime client for API `platform` headers.
 * Do not use `Platform.OS` alone — Expo web can report `android`.
 */
export function getClientPlatform(): ClientPlatform {
  if (typeof document !== 'undefined') {
    return 'Web App';
  }
  if (Platform.OS === 'ios') {
    return 'iOS App';
  }
  if (Platform.OS === 'android') {
    return 'Android App';
  }
  return 'Web App';
}
